/**
 * Reloj de la frontera UI→engine (DI, stack §6). El engine jamás llama
 * Date.now(); la UI estampa `at` en los eventos con esta función, que los
 * tests y el simulador reemplazan.
 */
export let now: () => number = () => Date.now();

export function setClock(fn: () => number): void {
  now = fn;
}
